import Vue from 'vue'
import VModal from 'vue-js-modal'

window._ = require('lodash');
window.$ = window.jQuery;
window.$j = window.jQuery2
window.numeral = require("numeral");
window.axios = require('axios');
// window.axios.defaults.baseURL = '/cs_schedule';

let loader;

window.axios.interceptors.request.use(config => {
  loader = vm.$loading.show();
  return config
})

window.axios.interceptors.response.use(function (response) {
  loader.hide();
  return response;
}, function (error) {
  loader.hide();
  return Promise.reject(error);
})

window.moment = require('moment');
Vue.use(require('vue-moment'));

window.lockOrder = '';

window.isInt = function (n) {
  return n % 1 === 0;
}


Vue.use(VModal, { dialog: true })

Vue.config.productionTip = false;

import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.min.css';
Vue.component('manage-schedule', require('~/pages/manage_schedule').default);
Vue.component('user-schedule', require('~/pages/user_schedule').default);
Vue.component('package-item', require('~/pages/package_item').default);
Vue.component('package-view', require('~/pages/package_view').default);
Vue.use(Loading);

Vue.filter("number_format", function (value) {
  if(value===0)return 0;
  if(value=='')return '';

  return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
});



window.vm = new Vue({
  el: '#app',
  data(){
    return{
      loading:true
    }
  },
  mounted(){

  }
});





// WEBPACK FOOTER //
// ./src/main.js